export enum LabelError {
  SMN = 'SMN',
  COUNTRY_REGISTRATION_NUMBER = 'Country Registration Number',
  OTHER = 'Other',
}
